import React, { useCallback } from "react";
import { SdaUncontrolled } from "./sda-uncontrolled";
import { buildUrl, SDA_API_URL } from "../../config/urls";
import { fetchWithTimeout } from "../../helpers/fetcher";
import * as adobeAnalytics from "../../utility/adobe-analytics";
import { useParams } from "react-router-dom";
import { getCandidateData } from "../../utility/candidate-data";
import { isDragonstone } from "../../helpers/url-params";

export const Sda = () => {
  const { requisitionId, applicationId } = useParams<{
    requisitionId: string;
    applicationId: string;
  }>();

  const sdaAccessor = useCallback(() => {
    const url = buildUrl(SDA_API_URL, {
      applicationId,
    });
    return fetchWithTimeout(url);
  }, []) as any;

  const sendAnalyticsEvent = useCallback(
    async (eventName: string) => {
      const { sfCandidateId } = await getCandidateData(applicationId);
      adobeAnalytics.addEventMetric(window, applicationId, eventName, {
        candidate: {
          CID: sfCandidateId,
        },
        jobId: requisitionId,
        isDragonstone: isDragonstone(requisitionId),
      });
    },
    [applicationId, requisitionId]
  );

  const trackViewDetailsClick = useCallback(() => sendAnalyticsEvent("first day what to expect click"), [
    sendAnalyticsEvent,
  ]);

  const trackChangeLinkClick = useCallback(() => sendAnalyticsEvent("first day change link click"), [
    sendAnalyticsEvent,
  ]);

  const trackSupportLinkClick = useCallback(() => sendAnalyticsEvent("first day change support link click"), [
    sendAnalyticsEvent,
  ]);

  if (!isDragonstone(requisitionId)) {
    return null;
  }

  return (
    <SdaUncontrolled
      sdaAccessor={sdaAccessor}
      onViewDetailsClick={trackViewDetailsClick}
      onChangeClick={trackChangeLinkClick}
      onSupportLinkClick={trackSupportLinkClick}
    />
  );
};
